//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";

moment.locale('fr');

export default {
    props: {
        dates: {
            required: true,
            type: Array,
            default: [],
        },
        token: {
            type: String,
            required: true,
        },
        lang:{
            required: true
        }
    },
    data() {
        return {
            disableDuringAction: false,
            selectedDates: [],
            note: '',
        }
    },
    methods: {
        handleSubmit()
        {
            const data = {
                token: this.token,
                note: this.note,
                dates: this.selectedDates,
            };

            this.disableDuringAction = true;

            this.$app.get('axios').post('/api/funnel/appointment?lang=' + this.lang, data ).then( response => {
                if ( response.data === true ) {
                    window.dataLayer?.push( { 'event': 'step5next' } );

                    this.$nextTick( () => this.$emit('submit') )
                }

                this.disableDuringAction = false;
            } ).catch( () => {
                this.disableDuringAction = false;
            } );
        },

        formatDate(date)
        {
            return moment( String( date ) ).format( 'DD MMMM YYYY [à] hh[h]mm')
        },

        handleCheckbox(date)
        {
            const index = this.selectedDates.indexOf( date );

            if ( index === -1 ) {
                this.selectedDates.push( date );
            } else {
                this.selectedDates.splice( index, 1 );
            }
        }
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step5in' } );
    }
}
